'use strict';

var $ = require('jquery');
var _ = require('lodash');

/**
 * Chart Context Menu Directive
 * @constructor
 * @requires ChartDirective
 */
var AnalysisContextMenuDirective = function AnalysisContextMenuDirective($document, constants) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/analysis-context-menu.html'),
    scope: {
      menuItems: '=',
      visibleData: '='
    },
    link: function link(scope, element) {
      var chartElement = element.parent().find('.chart-container');
      if (!chartElement) {
        throw new Error('AnalysisContextMenuDirective must be placed in ChartDirective');
      }
      scope.triggerContextMenuAction = function (item) {
        if (item) {
          _.each(scope.menuItems, function (i) {
            i.active = i.season === item.season;
          });
        }
        var selectedItem = _.find(scope.menuItems, {
          active: true
        });
        if (selectedItem) {
          var eventData = {
            season: selectedItem.season
          };
          scope.$emit('context-menu:analysis-chart-assign', eventData);
        }
      };
      scope.closeContextMenu = function () {
        element.hide();
      };
      scope.$on('context-menu:close', function () {
        _.each(scope.menuItems, function (i) {
          i.active = false;
        });
        element.hide();
      });
      scope.isHistorical = function () {
        return scope.visibleData === constants.REVIEW_SEASONALITY_MODES.HISTORICAL;
      };
      chartElement.on('contextmenu', function (event) {
        $('.analysis-chart-tooltip').first().css('top', 0);
        element.css({
          display: 'block',
          left: parseInt(event.originalEvent.clientX) + 15 + $(window).scrollLeft(),
          top: parseInt(event.originalEvent.clientY) - 50 + $(window).scrollTop()
        });
        return false;
      });
      function hideOnWindowClick(event) {
        if ($(event.target).closest(element).length === 0) {
          element.hide();
          scope.$apply();
        }
      }
      $document.on('click', hideOnWindowClick);
      element.on('$destroy', function () {
        $document.off('click', hideOnWindowClick);
      });
    }
  };
};
AnalysisContextMenuDirective.$inject = ['$document', 'SeasonalityConstants'];
module.exports = AnalysisContextMenuDirective;